import React from "react"
import { getBrandStateLabel } from "../../../../utils/brandStateLabels"

interface BrandStateLabelProps {
  brandState: string
  className?: string
  showTooltip?: boolean
}

const BrandStateLabel: React.FC<BrandStateLabelProps> = ({
  brandState,
  className = "",
  showTooltip = false,
}) => {
  const label = getBrandStateLabel(brandState)

  if (showTooltip) {
    return (
      <div
        className={`${className}`}
        title={brandState} // Show original value on hover
      >
        {label}
      </div>
    )
  }

  return <span className={className}>{label}</span>
}

export default BrandStateLabel
